export function getStyleProperty(element, property) {
  if (!element || !property || typeof window === "undefined") {
    return;
  }
  if (element.currentStyle) {
    return element.currentStyle[property];
  }
  const computedStyle = window.getComputedStyle(element, null);
  return computedStyle.getPropertyValue ? computedStyle.getPropertyValue(property) : computedStyle[property];
}
